import React, { useState, useEffect } from 'react'
import Slider from './Slider'
import * as rest from '../../services'
import { Field, reduxForm, change } from 'redux-form'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
import { FormButtons, renderers, validations } from '../../components'
import { useSelector } from 'react-redux'

import { getUserRoles } from '../../state/lists'
const ROLE_FORM_NAME = 'ChangeUserRoleForm'
let ChangeUserRoleForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  dispatch,
  user,
}) => {
  const { user_roles } = useSelector((state) => state.lists)

  useEffect(() => {
    !user_roles && dispatch(getUserRoles(user))
    if (user_roles) {
      user_roles.forEach((role) => {
        if (user.role === role.label)
          dispatch(change(ROLE_FORM_NAME, 'user_type', role.value))
      })
    }
  }, [user_roles, user, dispatch])

  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={renderers.renderSelectField}
        as="select"
        name="user_type"
        validate={[validations.required]}
        label="Role"
      >
        {user_roles &&
          user_roles.map((sp) => (
            <option key={sp.label} value={sp.value}>
              {sp.label}
            </option>
          ))}
      </Field>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
ChangeUserRoleForm = reduxForm({
  // a unique name for the form
  form: ROLE_FORM_NAME,
})(ChangeUserRoleForm)

const ChangeUserRolePane = ({ user, buttonType, onChange }) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const dispatch = useDispatch()
  const changeUserRole = (values) => {
    const action = 'change_user_role'
    rest.UserService.call_url_action(
      `${user.url}${action}`,
      'POST',
      values
    ).then(
      (response) => {
        dispatch(
          showSuccessToast(
            `${user.email} role changed`,
            `${user.email} role changed`
          )
        )
        onChange()
      },
      (errors) => {
        dispatch(
          showErrorToast(
            `error while changing role of ${user.email}`,
            errors.response.data
          )
        )
      }
    )
  }
  useEffect(() => {}, [])
  return (
    <>
      <Slider
        title="Change User Role"
        overlayClassName="on-top"
        buttonType={buttonType}
        isOpen={isPaneOpen}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <ChangeUserRoleForm user={user} onSubmit={changeUserRole} />
      </Slider>
    </>
  )
}

export default ChangeUserRolePane
